import React, { useState } from "react";
import Modal from "react-modal";

import SectionTitle from "../shared/components/sectionTitle";
import Loader from "../shared/components/loader";

import usePageFetcher from "../repository/usePageFetcher";

import "./style.css";

const VideoGallery = () => {
  const { isLoading, data } = usePageFetcher("video-gallery/");

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const closeModal = () => setModalIsOpen(false);

  return (
    <div className="video_gallery_wrapper">
      <div className="content_wrapper video_gallery_container">
        <SectionTitle title={"VIDEOGALEREYA"} />
        {isLoading ? (
          <Loader />
        ) : (
          <div className="videos_wrapper">
            {data?.map((item, index) => (
              <>
                <div
                  className="galery_card_video"
                  style={
                    index % 2 === 0
                      ? { flexDirection: "row-reverse" }
                      : { flexDirection: "row" }
                  }
                >
                  <div className="galery_card_video_wrapper">
                    <iframe
                      width="100%"
                      height="250px"
                      src={item.youtube_link}
                      title="YouTube video player"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerPolicy="strict-origin-when-cross-origin"
                      allowFullScreen
                    ></iframe>
                  </div>
                </div>

                <Modal
                  isOpen={modalIsOpen}
                  onRequestClose={closeModal}
                  contentLabel="Video Modal"
                  className="modal"
                  overlayClassName="overlay"
                  appElement={document.getElementById("root")}
                >
                  <button onClick={closeModal} className="modal_close_button">
                    x
                  </button>
                  <iframe
                    width="100%"
                    height="100%"
                    src={item.youtube_link}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                  ></iframe>
                </Modal>
              </>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default VideoGallery;
